import {
  NuvemEnvioErroredLabelDto,
  NuvemEnvioLabelErrorDto,
} from '@tiendanube/common';

export type LabelError = NuvemEnvioLabelErrorDto | NuvemEnvioErroredLabelDto;

export function combineLabelErrorCodes(
  createErrors?: ReadonlyArray<NuvemEnvioLabelErrorDto>,
  searchErrors?: ReadonlyArray<NuvemEnvioErroredLabelDto>,
  isTimeout?: boolean,
): string {
  const createCodes = createErrors?.map((e) => e.code).filter(Boolean) ?? [];
  const searchCodes =
    searchErrors?.map((e) => e.errorCode).filter(Boolean) ?? [];

  const unique = Array.from(new Set([...createCodes, ...searchCodes]));

  if (isTimeout && unique.length === 0) return 'timeout';

  return unique.length ? unique.join(', ') : 'unknown_error';
}
